// MA-1120 (RED r1 M1) — the rung a STORED placement result resolved to, for
// every reader that turns a stored diagnostic back into a module (MA-784's
// fresh-device restore, evidenceFloor's storedDiagnosticModule, the parent
// where-now card). Since MA-1120 both writers (onboarding's check-in and the
// readiness-check prefill) store `placementRung`: the rung the run PLACED at,
// whose module is the one the start rule wrote. A row written before has only
// `finalRung` (the reducer's terminal rung, which is what the old raise rule
// resolved from), so it falls back to that. A leaf: no imports.
export function diagnosticResultRung(result: { placementRung?: unknown; finalRung?: unknown } | null | undefined): number | null {
  if (!result || typeof result !== "object") return null;
  const p = result.placementRung;
  if (typeof p === "number" && Number.isInteger(p) && p >= 0) return p;
  const f = result.finalRung;
  return typeof f === "number" ? f : null;
}
